import { Action } from '@ngrx/store';

export enum ConvertActionTypes {
  CONVERT_KRONAS_TO_JSON = '[SHARED TOAST] Convert Kronas file to JSON',
  CONVERT_KRONAS_TO_JSON_SUCCESS = '[SHARED TOAST] Convert Kronas file to JSON Success',
  CONVERT_KRONAS_TO_JSON_ERROR = '[SHARED TOAST] Convert Kronas file to JSON Error',
}

export class ConvertKronasToJSON implements Action {
  readonly type = ConvertActionTypes.CONVERT_KRONAS_TO_JSON;
  constructor(public payload: any) {}
}
export class ConvertKronasToJSONSuccess implements Action {
  readonly type = ConvertActionTypes.CONVERT_KRONAS_TO_JSON_SUCCESS;
  constructor(public payload: any) {}
}
export class ConvertKronasToJSONError implements Action {
  readonly type = ConvertActionTypes.CONVERT_KRONAS_TO_JSON_ERROR;
  constructor(public payload: any) {}
}

export type ConvertActions =
  | ConvertKronasToJSON
  | ConvertKronasToJSONSuccess
  | ConvertKronasToJSONError;
